import {
  Flex,
  Text,
  Box,
  Collapse,
  useDisclosure,
  useTheme,
} from '@chakra-ui/react';
import ProviderCard from './ResultsContainer/ProviderCard';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { CJAnimatedLogoBreath } from 'cj-common-react';
import { useState, useEffect } from 'react';
import NoResultsPanel from './ResultsContainer/NoResultsPanel';

const ResultsContainer = ({
  providers,
  totalSearchResultsCount,
  isLoading,
  searchParameters,
}) => {
  const { isOpen, onToggle } = useDisclosure();
  const [opacity, setOpacity] = useState(0);
  const theme = useTheme();

  useEffect(() => {
    if (isLoading) {
      setOpacity(1);
    } else {
      setOpacity(0);
    }
  }, [isLoading]);
  const baseFilters = [
    {
      name: 'LOCATION',
      value: 'Los Angeles, CA',
    },
    {
      name: 'KEYWORDS',
      value: 'Joint Pain, Sports Medicine',
    },
  ];

  if (isLoading) {
    return (
      <Flex
        bg='white'
        width='100%'
        height='100%'
        flexDirection='column'
        position='absolute'
        right={0}
        top='50%'
        transform='translateY(-50%)'
        borderTopRightRadius='8px'
        borderBottomRightRadius='8px'
        sx={{
          '& > *:not(:first-child)': {
            marginTop: '15px',
            padding: '0px 10px',
          },
        }}
      >
        <Flex
          width='100%'
          height='100%'
          position='absolute'
          zIndex='10'
          justifyContent='center'
          alignItems='center'
          transition='opacity 0.3s ease'
          style={{ opacity }}
        >
          <CJAnimatedLogoBreath width='100px' height='100px' />
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex
      bg='white'
      width='100%'
      height='100%'
      flexDirection='column'
      position='absolute'
      right={0}
      top='50%'
      transform='translateY(-50%)'
      borderTopRightRadius='8px'
      borderBottomRightRadius='8px'
      sx={{
        '& > *:not(:first-child)': {
          marginTop: '15px',
          padding: '0px 10px',
        },
      }}
    >
      {providers && (
        <>
          <Flex
            bgColor={theme.colors?.bgGrey2}
            flexDirection='column'
            position='relative'
            borderRadius='10px'
            padding='8px 5px'
            margin='15px 10px 0px 10px'
          >
            <Box color={theme.colors?.smoky} fontSize='1rem'>
              {providers?.length > 0 ? (
                <Text>
                  {`Out of over 1 million doctors, ${totalSearchResultsCount} meet your search criteria. Here are the ${providers.length} best doctors based on
                    expertise and quality related to your specific search.`}
                </Text>
              ) : (
                <Text>
                  {`Out of over 1.000.000 doctors, 0 meet your search criteria.`}
                </Text>
              )}
            </Box>
            <Flex
              flexDirection='column-reverse'
              color={theme.colors?.smoky}
              fontSize='1rem'
            >
              <Box alignSelf='flex-end'>
                <Text as='b' cursor='pointer' onClick={onToggle}>
                  How do we choose them?
                  {isOpen ? (
                    <ChevronUpIcon boxSize='24px' marginBottom='2px' />
                  ) : (
                    <ChevronDownIcon boxSize='24px' marginBottom='2px' />
                  )}
                </Text>
              </Box>
              <Box alignSelf='flex-end'>
                <Collapse in={isOpen}>
                  <Text marginTop='5px'>
                    <strong>
                      <em>Expertise</em>
                    </strong>{' '}
                    is the number of patients treated in this specific condition
                    compared to peers in the same speciality and geography.
                  </Text>
                  <Text marginTop='5px'>
                    <strong>
                      <em>Quality</em>
                    </strong>{' '}
                    is based on the score that patients give to the doctor based
                    on their overall experience.
                  </Text>
                </Collapse>
              </Box>
            </Flex>
          </Flex>
          {/* MVP RELEASE DOES NOT NEED */}
          {/* <Grid templateColumns='40% 40% 20%' gap='4px'>
                {baseFilters.map((filter) => (
                  <CardFilter filter={filter} key={filter.name} />
                ))}
                <Button bgColor='#EC9F24' color='white' width='120px'>
                  More Filters
                </Button>
              </Grid> */}
          {providers?.length > 0 ? (
            <Box
              flexDirection='column'
              overflowY='scroll'
              height='100%'
              minHeight={0}
            >
              {providers.map((provider, i) => (
                <ProviderCard
                  key={i}
                  provider={provider}
                  searchParameters={searchParameters}
                />
              ))}
            </Box>
          ) : (
            <Flex
              direction='column'
              align='center'
              justify='flex-start'
              width='100%'
              height='100%'
            >
              <NoResultsPanel />
            </Flex>
          )}
        </>
      )}
    </Flex>
  );
};

export default ResultsContainer;
